<div class="mon-chart">
    <canvas [attr.height]="height"
            class="chart-bubble"
            chartBase
            [chartType]="'bubble'"
            [chartData]="data"
            [chartLabels]="labels"
            [chartSeries]="series"
            [chartOptions]="options"
            [chartDatasetOverride]="override"
            [chartColors]="colors">
    </canvas>
</div>
